import React from "react";
import { NavLink } from "react-router-dom";

const RenewPayCard = (props) => {
  return (
    <div className="cpay">
      <div className="cpay__wrap">
        <div className="cpay__box">
          {/* Left Section */}
          <div className="cpay__box__left">
            <h2 className="cpay__box__left-txt text-jost-sb-22">Payment Method</h2>

            {/* Card Selection */}
            <div className="cpay__box__left-card">
              <div className="footer__nav-check">
                <input type="radio" id="pay_agree" name="payment" value="" />
                <label htmlFor="pay_agree" className="checkmark_ft"></label>
              </div>
              <img src={require("../../../assets/images/card/card_1.svg").default} alt="Card 1" />
              <img src={require("../../../assets/images/card/card_2.svg").default} alt="Card 2" />
              <img src={require("../../../assets/images/card/card_3.svg").default} alt="Card 3" />
            </div>

            {/* Card Details Form */}
            <div className="cpay__box__left-cdetail">
              <div className="cpay__box__left-cname">
                <label htmlFor="card_name" className="label__set">Name On Card*</label>
                <input className="form__input-md" type="text" id="card_name" placeholder="" required />
              </div>

              <div className="cpay__box__left__cdetail">
                <div className="cpay__box__left__cdetail-cnum">
                  <label htmlFor="card_number" className="label__set">Card Number*</label>
                  <input className="form__input-md" type="text" id="card_number" placeholder="" required />
                </div>

                <div className="cpay__box__left__cdetail-edate">
                  <label htmlFor="expiry_date" className="label__set">Expiry Date</label>
                  <input className="form__input-md" type="text" id="expiry_date" placeholder="" required />
                </div>

                <div className="cpay__box__left__cdetail-cvv">
                  <label htmlFor="cvv" className="label__set">CV2</label>
                  <input className="form__input-md" type="text" id="cvv" placeholder="" required />
                </div>

                <div className="cpay__box__left__cdetail-warn">
                  <a href="/">
                    <img src={require("../../../assets/images/warning/warning_pay.svg").default} alt="Warning" />
                    What is this?
                  </a>
                </div>
              </div>
            </div>

            {/* Billing Details */}
            <div className="cpay__box__left__check">
              <input type="checkbox" id="bill_add" name="billing_details" value="" />
              <label htmlFor="bill_add"></label>
              <span className="text-jost-sb-19">Billing details are the same as Club Address</span>
            </div>

            <div className="cpay__box__left__add">
              <input
                className="form__input-md"
                type="text"
                placeholder="Start to type your address..."
                name="address_1"
                required
              />
              <input
                className="form__input-md"
                type="text"
                placeholder="Address Line 2"
                name="address_2"
                required
              />
              <input className="form__input-md" type="text" placeholder="Town" name="town" required />
              <input className="form__input-md" type="text" placeholder="County*" name="county" required />
              <input className="form__input-md" type="text" placeholder="Postcode*" name="postcode" required />
            </div>

            {/* PayPal Option */}
            <div className="cpay__box__left-paypal">
              <div className="footer__nav-check">
                <input type="radio" id="pay_agree_2" name="payment" value="" />
                <label htmlFor="pay_agree_2" className="checkmark_ft"></label>
              </div>
              <img src={require("../../../assets/images/card/card_4.svg").default} alt="PayPal" />
            </div>
          </div>

          {/* Right Section */}
          <div className="cpay__box__right">
            <h2 className="cpay__box__right-txt text-jost-sb-22">Payment Summary</h2>

            {/* Summary Items */}
            <div className="cpay__box__right__count">
              <div className="cpay__box__right__count-head">
                <h3 className="text-ops-sm-16">Item</h3>
                <h3 className="text-ops-sm-16">Monthly</h3>
              </div>
              <div className="cpay__box__right__count-total">
                <span className="text-ops-b-18">Total</span>
                <span className="text-ops-b-18">£7.00</span>
                <span className="text-ops-b-18">£70.00</span>
              </div>
            </div>

            {/* Payment Options */}
            <h2 className="text-jost-sb-22">How would you like to pay?</h2>
            <div className="cpay__box__right__paywrap">
              <div className="cpay__box__right__paywrap-payop">
                <input type="radio" id="pay_month" name="pay" value="" />
                <label htmlFor="pay_month">
                  <span className="text-jost-sb-22-wt">Pay Monthly</span>
                  <span className="text-jost-sb-22-wt">£7.00</span>
                </label>
              </div>

              <div className="cpay__box__right__paywrap-payop">
                <input type="radio" id="pay_year" name="pay" value="" />
                <label htmlFor="pay_year">
                  <div className="text-jost-sb-22-wt">Pay Annually</div>
                  <div className="text-jost-sb-22-wt">£70.00</div>
                </label>
              </div>
            </div>

            {/* Terms and Conditions */}
            <div className="cpay__box__right-check">
              <input type="checkbox" id="check_pay" name="terms" value="" />
              <label htmlFor="check_pay"></label>
              <span className="text-ops-rg-15-cap">
                I Agree To Timely Golf’s <a href="/">Terms & Conditions</a>
              </span>
            </div>

            {/* Pay Now Button */}
            <div className="cpay-links">
              <NavLink to="/pay-confirm" target="_self" className="res-btn-primary">
                Pay Now
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewPayCard;
